import styled from 'styled-components'

const TypeaheadResult = styled.span`
  display: block;
  width: 100%;
  font-size: 16px;
  text-align: left;
  padding: 8px 12px;
  background-color: ${({ theme }) => theme.backgroundAlternate};
  color: ${({ theme }) => theme.text};
  transition: 150ms ease;
  &:hover {
    background-color: ${({ theme }) => theme.tags};
  }
`

export default TypeaheadResult
